module.exports = "/_next/static/images/gs-7b9175161dcf7ea2bd55c0612f0b8d1a.svg";